import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "utils/url.utils";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/notifications"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const notificationsApi = createApi({
    reducerPath: "notificationsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ['Notifications'],
    endpoints: (builder) => ({
        getNotifications: builder.query({
            query: ({ limit } = {}) => {
                let query = '';
                if (limit) {
                    query = `?limit=${limit}`;
                }
                return `/${query}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ['Notifications'],
        }),
        markNotificationAsRead: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: 'POST',
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ['Notifications'],
        }),
    }),
});

export const {
    useGetNotificationsQuery,
    useLazyGetNotificationsQuery,
    useMarkNotificationAsReadMutation
} = notificationsApi;
